import axios from "axios";
import { JSON_URL } from "../../config/RouterLink";


//------------- STATE -------------------------
const initialState = {
    /* Loading */
    isLoading: false,
    /* Error */
    messageError: "",
    /* Lista Tipo de Aspirantes */
    ListTipoAspirantes: [],
    /* Lista Protestos */
    idListProtesto: 0,
    ListProtestos: [],
    /* Parametros Generales */
    ParametrosGeneralesProtesto:[],
    /* Valor Ultimo Protesto Aceptado */
    ultimoProtestoAceptado : false,
    ListultimoProtestoAceptado:[],
    /* Insert */
    isInsertTAspProtes: false,
    isInsertTAspProtesStatus: 0,
    isInsertTAspProtesMessage: '',
    /* Update */
    isUpdateTAspProtes: false,
    isUpdateTAspProtesStatus: 0,
    isUpdateTAspProtesMessage: ''
}

//------------- TYPES -------------------------
/* Loading */
const LOADING_T_ASP_PROTES = 'LOADING_T_ASP_PROTES';
/* Gets */
const GET_TIPO_ASPIRANTES_T_ASP_PROTES = "GET_TIPO_ASPIRANTES_T_ASP_PROTES";
const GET_LISTA_PROTESTOS_T_ASP_PROTES = "GET_LISTA_PROTESTOS_T_ASP_PROTES";
const GET_PARAMETROS_GENERALES_T_ASP_PROTES = "GET_PARAMETROS_GENERALES_T_ASP_PROTES";
const GET_ULTIMO_PROTESTO_ACEPTADO_T_ASP_PROTES = "GET_ULTIMO_PROTESTO_ACEPTADO_T_ASP_PROTES";
/* Inserts */
const INSERT_PROTESTO_TIPO_ASPIRANTE_T_ASP_PROTES = "INSERT_PROTESTO_TIPO_ASPIRANTE_T_ASP_PROTES";
const INSERT_PROTESTO_TIPO_ASPIRANTE_T_ASP_PROTES_MESSAGE = "INSERT_PROTESTO_TIPO_ASPIRANTE_T_ASP_PROTES_MESSAGE";
/* Updates */
const UPDATE_PROTESTO_TIPO_ASPIRANTE_T_ASP_PROTES = "UPDATE_PROTESTO_TIPO_ASPIRANTE_T_ASP_PROTES";
const UPDATE_PROTESTO_TIPO_ASPIRANTE_T_ASP_PROTES_MESSAGE = "UPDATE_PROTESTO_TIPO_ASPIRANTE_T_ASP_PROTES_MESSAGE";
/* Errors Service */
const SERVICIO_T_ASP_PROTES_ERROR = 'SERVICIO_T_ASP_PROTES_ERROR';
const SERVICIO_T_ASP_PROTES_OFFLINE = 'SERVICIO_T_ASP_PROTES_OFFLINE';

//------------- REDUCER -------------------------
export default function TipoAspiranteProtestoReducer (state = initialState, action){
    switch (action.type) {
        /* Loading */
        case LOADING_T_ASP_PROTES:
            return {
                ...state,
                isLoading: action.payload
            }
        /* Gets */
        case GET_TIPO_ASPIRANTES_T_ASP_PROTES:
            return {
                ...state,
                ListTipoAspirantes: action.payload
            }
        case GET_LISTA_PROTESTOS_T_ASP_PROTES:
            return {
                ...state,
                ListProtestos: action.payload.listaProtestos,
                idListProtesto: action.payload.idProtesto
            }
        case GET_PARAMETROS_GENERALES_T_ASP_PROTES:
            return {
                ...state,
                ParametrosGeneralesProtesto: action.payload
            }
        case GET_ULTIMO_PROTESTO_ACEPTADO_T_ASP_PROTES:
            return {
                ...state,
                ultimoProtestoAceptado: action.payload.aceptado,
                ListultimoProtestoAceptado: action.payload.aceptadoList
            }
        /* Inserts */
        case INSERT_PROTESTO_TIPO_ASPIRANTE_T_ASP_PROTES:
            return {
                ...state,
                isInsertTAspProtes: !state.isInsertTAspProtes
            }
        case INSERT_PROTESTO_TIPO_ASPIRANTE_T_ASP_PROTES_MESSAGE:
            return {
                ...state,
                isInsertTAspProtesStatus: action.payload.mensajeId,
                isInsertTAspProtesMessage: action.payload.mensaje
            }
        /* Updates */
        case UPDATE_PROTESTO_TIPO_ASPIRANTE_T_ASP_PROTES:
            return {
                ...state,
                isUpdateTAspProtes: !state.isUpdateTAspProtes
            }
        case UPDATE_PROTESTO_TIPO_ASPIRANTE_T_ASP_PROTES_MESSAGE:
            return {
                ...state,
                isUpdateTAspProtesStatus: action.payload.mensajeId,
                isUpdateTAspProtesMessage: action.payload.mensaje
            }
        /* Errors Service */
        case SERVICIO_T_ASP_PROTES_ERROR:
            return {
                ...state,
                messageError: action.payload,
            }
        case SERVICIO_T_ASP_PROTES_OFFLINE:
            return {
                ...state,
                messageError: "El sistema se encuentra fuera de servicio, favor de acceder más tarde.",
            };
        default:
        return state;
    }
}; 

//------------- FUNCTIONS -------------------------
/* Gets */
export const getTipoAspirantesTAspProtes = () => async (dispatch, getState) => {
    dispatch({type: LOADING_T_ASP_PROTES, payload:true})
    const { data } = await axios(window.location.origin + JSON_URL);
    axios({
        url: `${data.urlServer}/ConcursoPublico/api/tipoAspiranteProtesto/getTipoAspirantes`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + getState().usuarioLogin.accessToken
        }
    })
    .then(function (res) {
        dispatch({type: LOADING_T_ASP_PROTES, payload:false})
        dispatch({type: GET_TIPO_ASPIRANTES_T_ASP_PROTES,payload:res.data.tipoAspirantes});
        
    })
    .catch((err) => {
        dispatch({type: LOADING_T_ASP_PROTES, payload:false})
        if (err.response === undefined) {
            dispatch({ type: SERVICIO_T_ASP_PROTES_OFFLINE });
        } else {
           /*  Error con cualquier status de error */
            if (err.response.status !== '') {
                
                dispatch({
                    type: SERVICIO_T_ASP_PROTES_ERROR,
                    payload: err.response.statusText
                });
            }
        }
    });
}
export const getListaProtestosTAspProtes = (dataJSON) => async (dispatch, getState) => {
    dispatch({type: LOADING_T_ASP_PROTES, payload:true})
    const { data } = await axios(window.location.origin + JSON_URL);
    axios({
        url: `${data.urlServer}/ConcursoPublico/api/tipoAspiranteProtesto/getListaProtestos`,
        method: 'POST',
        data:dataJSON,
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + getState().usuarioLogin.accessToken
        }
    })
    .then(function (res) {
        dispatch({type: LOADING_T_ASP_PROTES, payload:false})

        if(res.data.listaProtestos !== undefined){
            res.data.listaProtestos.forEach(element =>{
                let listaProtestos = element.descripcion;
                let idProtesto = element.idProtesto;
                dispatch({type: GET_LISTA_PROTESTOS_T_ASP_PROTES,payload:{listaProtestos,idProtesto}});
            })
        }
    })
    .catch((err) => {
        dispatch({type: LOADING_T_ASP_PROTES, payload:false})
        if (err.response === undefined) {
            dispatch({ type: SERVICIO_T_ASP_PROTES_OFFLINE });
        } else {
           /*  Error con cualquier status de error */
            if (err.response.status !== '') {
                
                dispatch({
                    type: SERVICIO_T_ASP_PROTES_ERROR,
                    payload: err.response.statusText
                });
            }
        }
    });
}
export const getParametrosGeneralesTAspProtes = () => async (dispatch, getState) => {
    dispatch({type: LOADING_T_ASP_PROTES, payload:true})
    const { data } = await axios(window.location.origin + JSON_URL);
    axios({
        url: `${data.urlServer}/ConcursoPublico/api/catalogo/parametro/general`,
        method: 'POST',
        data: {
            "idValor": 16
        },
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + getState().usuarioLogin.accessToken
        }
    })
    .then(function (res) {
        dispatch({type: LOADING_T_ASP_PROTES, payload:false})
        dispatch({type: GET_PARAMETROS_GENERALES_T_ASP_PROTES,payload:res.data});
    })
    .catch((err) => {
        dispatch({type: LOADING_T_ASP_PROTES, payload:false})
        if (err.response === undefined) {
            dispatch({ type: SERVICIO_T_ASP_PROTES_OFFLINE });
        } else {
           /*  Error con cualquier status de error */
            if (err.response.status !== '') {
                
                dispatch({
                    type: SERVICIO_T_ASP_PROTES_ERROR,
                    payload: err.response.statusText
                });
            }
        }
    });
}
export const getUltimoProtestoAceptadoTAspProtes = (dataJSON) => async (dispatch, getState) => {
    dispatch({type: LOADING_T_ASP_PROTES, payload:true})
    const { data } = await axios(window.location.origin + JSON_URL);
    axios({
        url: `${data.urlServer}/ConcursoPublico/api/tipoAspiranteProtesto/obtenerProtestoTipoAspirante`,
        method: 'POST',
        data:dataJSON,
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + getState().usuarioLogin.accessToken
        }
    })
    .then(function (res) {
        dispatch({type: LOADING_T_ASP_PROTES, payload:false})
        let aceptado = false;
        let aceptadoList = res.data.protestoTipoAspirante;

        if(res.data.protestoTipoAspirante.length === 0){
           aceptado = false;
        }else{
            aceptado = true;
        }
        
        dispatch({type: GET_ULTIMO_PROTESTO_ACEPTADO_T_ASP_PROTES,payload:{aceptado, aceptadoList}});

    })
    .catch((err) => {
        dispatch({type: LOADING_T_ASP_PROTES, payload:false})
        if (err.response === undefined) {
            dispatch({ type: SERVICIO_T_ASP_PROTES_OFFLINE });
        } else {
           /*  Error con cualquier status de error */
            if (err.response.status !== '') {
                
                dispatch({
                    type: SERVICIO_T_ASP_PROTES_ERROR,
                    payload: err.response.statusText
                });
            }
        }
    });
}
/* Inserts */
export const insertProtestoTipoAspiranteTAspProtes = (dataJSON) => async (dispatch, getState) => {
    dispatch({type: LOADING_T_ASP_PROTES, payload:true})
    const { data } = await axios(window.location.origin + JSON_URL);
    axios({
        url: `${data.urlServer}/ConcursoPublico/api/tipoAspiranteProtesto/insertarProtestoTipoAspirante`,
        method: 'POST',
        data:dataJSON,
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + getState().usuarioLogin.accessToken
        }
    })
    .then(function (res) {
        dispatch({type: LOADING_T_ASP_PROTES, payload:false})
        dispatch(setIsInsertProtestoTipoAspiranteTAspProtesMessage(res.data)).then ( 
            dispatch(setIsInsertProtestoTipoAspiranteTAspProtes())
        );

    })
    .catch((err) => {
        dispatch({type: LOADING_T_ASP_PROTES, payload:false})
        if (err.response === undefined) {
            dispatch({ type: SERVICIO_T_ASP_PROTES_OFFLINE });
        } else {
           /*  Error con cualquier status de error */
            if (err.response.status !== '') {
                
                dispatch({
                    type: SERVICIO_T_ASP_PROTES_ERROR,
                    payload: err.response.statusText
                });
            }
        }
    });
}
/* Updates */
export const updateProtestoTipoAspiranteTAspProtes = (dataJSON) => async (dispatch, getState) => {
    dispatch({type: LOADING_T_ASP_PROTES, payload:true})
    const { data } = await axios(window.location.origin + JSON_URL);
    axios({
        url: `${data.urlServer}/ConcursoPublico/api/tipoAspiranteProtesto/actualizarProtestoTipoAspirante`,
        method: 'POST',
        data:dataJSON,
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + getState().usuarioLogin.accessToken
        }
    })
    .then(function (res) {
        dispatch({type: LOADING_T_ASP_PROTES, payload:false})
        dispatch(setIsUpdateProtestoTipoAspiranteTAspProtesMessage(res.data)).then ( 
            dispatch(setIsUpdateProtestoTipoAspiranteTAspProtes())
        );

    })
    .catch((err) => {
        dispatch({type: LOADING_T_ASP_PROTES, payload:false})
        if (err.response === undefined) {
            dispatch({ type: SERVICIO_T_ASP_PROTES_OFFLINE });
        } else {
           /*  Error con cualquier status de error */
            if (err.response.status !== '') {
                
                dispatch({
                    type: SERVICIO_T_ASP_PROTES_ERROR,
                    payload: err.response.statusText
                });
            }
        }
    });
}

/* SETS */
export const setIsInsertProtestoTipoAspiranteTAspProtes = () => async (dispatch, getState) => {
    dispatch({ type: INSERT_PROTESTO_TIPO_ASPIRANTE_T_ASP_PROTES });
}
export const setIsInsertProtestoTipoAspiranteTAspProtesMessage = (dataJSON) => async (dispatch, getState) => {
    dispatch({ type: INSERT_PROTESTO_TIPO_ASPIRANTE_T_ASP_PROTES_MESSAGE, payload: dataJSON });
}

export const setIsUpdateProtestoTipoAspiranteTAspProtes = () => async (dispatch, getState) => {
    dispatch({ type: UPDATE_PROTESTO_TIPO_ASPIRANTE_T_ASP_PROTES });
}
export const setIsUpdateProtestoTipoAspiranteTAspProtesMessage = (dataJSON) => async (dispatch, getState) => {
    dispatch({ type: UPDATE_PROTESTO_TIPO_ASPIRANTE_T_ASP_PROTES_MESSAGE, payload: dataJSON });
}


